var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCharactersArtifactsTablet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 744,
    height: 1132,
    viewBox: "0 0 744 1132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 203.2,
    y: 654.1,
    className: "st0",
    width: 3.7,
    height: 3,
    fill: "#E9ABE1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 203.6,
    y: 753.2,
    className: "st0",
    width: 6.7,
    height: 6,
    fill: "#E9ABE1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 202.9,
    y: 785.9,
    className: "st0",
    width: 1.5,
    height: 1.5,
    fill: "#E9ABE1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 631.5,
    y: 252,
    className: "st0",
    width: 2.2,
    height: 1.5,
    fill: "#E9ABE1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 624,
    y: 252,
    className: "st0",
    width: 2.2,
    height: 1.5,
    fill: "#E9ABE1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 631.5,
    y: 255.7,
    className: "st0",
    width: 2.2,
    height: 1.5,
    fill: "#E9ABE1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 624,
    y: 255.7,
    className: "st0",
    width: 2.2,
    height: 1.5,
    fill: "#E9ABE1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 557.7,
    y: 551,
    className: "st0",
    width: 5.2,
    height: 5.2,
    fill: "#E9ABE1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 560.7,
    y: 562.9,
    className: "st0",
    width: 2.2,
    height: 0.7,
    fill: "#E9ABE1"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 560.7,
    y: 565.8,
    className: "st0",
    width: 2.2,
    height: 0.7,
    fill: "#E9ABE1"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 619.5,
    y: 649.2,
    className: "st0",
    width: 2.2,
    height: 1.5,
    fill: "#E9ABE1"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 691.8,
    y: 252,
    className: "st0",
    width: 2.2,
    height: 1.5,
    fill: "#E9ABE1"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 562.2,
    y: 649.2,
    className: "st0",
    width: 2.2,
    height: 1.5,
    fill: "#E9ABE1"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 200.7,
    y: 914.3,
    className: "st0",
    width: 2.2,
    height: 1.5,
    fill: "#E9ABE1"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 143.3,
    y: 914.3,
    className: "st0",
    width: 2.2,
    height: 1.5,
    fill: "#E9ABE1"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 250.3,
    y: 369.4,
    className: "st0",
    width: 2.2,
    height: 1.5,
    fill: "#E9ABE1"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 82.8,
    y: 369.4,
    className: "st0",
    width: 2.2,
    height: 1.5,
    fill: "#E9ABE1"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 257.7,
    y: 369.4,
    className: "st0",
    width: 2.2,
    height: 1.5,
    fill: "#E9ABE1"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 75.3,
    y: 365.7,
    className: "st0",
    width: 2.2,
    height: 1.5,
    fill: "#E9ABE1"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 250.3,
    y: 365.7,
    className: "st0",
    width: 2.2,
    height: 1.5,
    fill: "#E9ABE1"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 82.8,
    y: 365.7,
    className: "st0",
    width: 2.2,
    height: 1.5,
    fill: "#E9ABE1"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 257.7,
    y: 365.7,
    className: "st0",
    width: 2.2,
    height: 1.5,
    fill: "#E9ABE1"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 133.4,
    y: 336.6,
    className: "st0",
    width: 2.2,
    height: 1.5,
    fill: "#E9ABE1"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 132.7,
    y: 369.4,
    className: "st0",
    width: 2.2,
    height: 1.5,
    fill: "#E9ABE1"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 308.3,
    y: 73.8,
    className: "st0",
    width: 2.2,
    height: 1.5,
    fill: "#E9ABE1"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 423,
    y: 73.1,
    className: "st0",
    width: 2.2,
    height: 1.5,
    fill: "#E9ABE1"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 369.4,
    className: "st0",
    width: 2.2,
    height: 1.5,
    fill: "#E9ABE1"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 365.7,
    y: 73.8,
    className: "st0",
    width: 2.2,
    height: 1.5,
    fill: "#E9ABE1"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 480.3,
    y: 73.1,
    className: "st0",
    width: 2.2,
    height: 1.5,
    fill: "#E9ABE1"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 190.7,
    y: 335.9,
    className: "st0",
    width: 2.2,
    height: 1.5,
    fill: "#E9ABE1"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 252.1,
    y: 285.7,
    className: "st0",
    width: 6.7,
    height: 1.5,
    fill: "#E9ABE1"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 251.4,
    y: 252.2,
    className: "st0",
    width: 6.7,
    height: 1.5,
    fill: "#E9ABE1"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 630.9,
    y: 913.9,
    className: "st0",
    width: 2.2,
    height: 1.5,
    fill: "#E9ABE1"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 623.5,
    y: 913.9,
    className: "st0",
    width: 2.2,
    height: 1.5,
    fill: "#E9ABE1"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 630.9,
    y: 910.2,
    className: "st0",
    width: 2.2,
    height: 1.5,
    fill: "#E9ABE1"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 623.5,
    y: 910.2,
    className: "st0",
    width: 2.2,
    height: 1.5,
    fill: "#E9ABE1"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 522,
    y: 570.3,
    className: "st0",
    width: 5.2,
    height: 5.2,
    fill: "#E9ABE1"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 525,
    y: 562.9,
    className: "st0",
    width: 2.2,
    height: 0.7,
    fill: "#E9ABE1"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 525,
    y: 559.9,
    className: "st0",
    width: 2.2,
    height: 0.7,
    fill: "#E9ABE1"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 551.3,
    className: "st0",
    width: 5.2,
    height: 5.2,
    fill: "#E9ABE1"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 563.2,
    className: "st0",
    width: 2.2,
    height: 0.7,
    fill: "#E9ABE1"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 566.2,
    className: "st0",
    width: 2.2,
    height: 0.7,
    fill: "#E9ABE1"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 239.7,
    y: 570.7,
    className: "st0",
    width: 5.2,
    height: 5.2,
    fill: "#E9ABE1"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 239.7,
    y: 563.2,
    className: "st0",
    width: 2.2,
    height: 0.7,
    fill: "#E9ABE1"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 239.7,
    y: 560.3,
    className: "st0",
    width: 2.2,
    height: 0.7,
    fill: "#E9ABE1"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 562.4,
    y: 475.8,
    className: "st0",
    width: 2.2,
    height: 1.5,
    fill: "#E9ABE1"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 690.1,
    y: 913.9,
    className: "st0",
    width: 2.2,
    height: 1.5,
    fill: "#E9ABE1"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 505.1,
    y: 475.8,
    className: "st0",
    width: 2.2,
    height: 1.5,
    fill: "#E9ABE1"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 701.4,
    y: 737.8,
    className: "st0",
    width: 2.2,
    height: 1.5,
    fill: "#E9ABE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharactersArtifactsTablet);
export default __webpack_public_path__ + "static/media/characters-artifacts-tablet.10ef0f410144af97e31649d5380b4163.svg";
export { ForwardRef as ReactComponent };